import { get } from "./apiClient";

export default {
  async getByFacilityId(facilityId) {
    return await get(`facility/${encodeURIComponent(facilityId)}/quickNotes`);
  }
};
